import { render } from "./OficinaList.vue?vue&type=template&id=8e42ff3c"
import script from "./OficinaList.vue?vue&type=script&lang=js"
export * from "./OficinaList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__